import * as messageService from "../../services/message.service";
import * as settingAllService from '../../services/settingAll.service';
const state = {
    settingAll:{},
};

const getters = {
    getSettingAll:state => (state.settingAll),
};

const actions = {
    async fetchSettingAll({ commit } ){
        try {

            const resAllSettings = await settingAllService.all();
            let allSetting = {
                "australianResidencyStatus":resAllSettings.data.australianResidencyStatus,
                "businessUsePercentage": resAllSettings.data.businessesPercentage,
                "country":resAllSettings.data.country,
                "documentType":resAllSettings.data.documentType,
                "driversLicenceType":resAllSettings.data.driversLicenceType,
                "employmentStatus" : resAllSettings.data.employmentStatus,
                "fuelType": resAllSettings.data.fuelType,
                "leaseTerm":resAllSettings.data.leaseTerm,
                "lookupValue":resAllSettings.data.lookupValue,
                "otherIncome" : resAllSettings.data.otherIncome,
                "otherLoan" : resAllSettings.data.otherLoan,
                "payPeriod": resAllSettings.data.payPeriod,
                "residenceStatus": resAllSettings.data.residentialStatus,
                "salaryPackagingProvider":resAllSettings.data.salaryPackagingProvider,
                "state":resAllSettings.data.state,
                "taxTable":resAllSettings.data.taxTable,
                "transmission": resAllSettings.data.transmission,
                "vehicleCondition":resAllSettings.data.vehicleCondition,
                "vehicleCategory" : resAllSettings.data.vehicleCategory,
                "visaType":resAllSettings.data.visaType,
                "systemSetting":resAllSettings.data.systemSetting,
            }
            commit('setSettingAll', allSetting);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setSettingAll:(state, res) => (
        state.settingAll =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}
